module.exports = __webpack_public_path__ + "static/media/overtake.ceac210b.png";